import { ParsedUrlQuery } from 'querystring';

import { GalleryFilters, GalleryProducts } from '../typings';

export function getAvailableFilterValues(
  getFilterOptionsCallback: (
    filters: GalleryFilters,
    products: GalleryProducts,
    query: ParsedUrlQuery,
  ) => { value: string; label: string }[] | undefined,
  filters: GalleryFilters,
  products: GalleryProducts,
  query: ParsedUrlQuery,
): string[] {
  const filterOptions = getFilterOptionsCallback(filters, products, query);

  return filterOptions?.map((option) => option.value) || [];
}
